import {logger as SentryLogger} from '@sentry/react';
import {PlanOptions} from "@utils/planOptions";


export type SelectedSubscriptionState = {
    selectedSubsId: string | null;
    permanentVehicleId: string | null;
    selectedPlan: PlanOptions | string | null;
    temporaryVehicleId?: string | null;

};

export type SelectedSubscriptionAction = {
    type: "SELECT_SUBSCRIPTION";
    payload: { subsId: string; vehicleId: string, selectedPlan: string, temporaryVehicleId?: string | null };
};

export const selectedSubscriptionInitialState: SelectedSubscriptionState = {
    selectedSubsId: null,
    permanentVehicleId: null,
    selectedPlan: null
};

export function selectedSubscriptionReducer(state: SelectedSubscriptionState, action: SelectedSubscriptionAction): SelectedSubscriptionState {
    switch (action.type) {
        case "SELECT_SUBSCRIPTION":
            SentryLogger.debug("Selected subscription: " + JSON.stringify(action.payload));

            // Checks selectPlan is an expected value
            const planValues: any[] = Array.isArray(PlanOptions) ? PlanOptions : Object.values(PlanOptions);
            // Special case, Rav Short Term is stored as "RAV Short Term Rental Platinum" in Zoho Subscription
            if (action.payload.selectedPlan === "RAV Short Term Rental Platinum") {
                action.payload.selectedPlan = PlanOptions.RAVShortTermRental;
            }
            if (!planValues.includes(action.payload.selectedPlan)) {
                console.error("Error - selected plan is not a valid PlanOption: " + action.payload.selectedPlan);
            }

            return {
                ...state,
                selectedSubsId: action.payload.subsId,
                permanentVehicleId: action.payload.vehicleId,
                selectedPlan: action.payload.selectedPlan,
                temporaryVehicleId: action.payload.temporaryVehicleId || null
            };
        default:
            console.log(`Error - incorrect action sent ${action} ${state}`)
            return state;
    }
}